import React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import Tooltip from 'PyzShopUi/scripts/react/common/components/Tooltip';
import { AVAILABILITY_CONSTANTS } from 'PyzShopUi/scripts/constants/availability';
import Utils from 'PyzShopUi/scripts/utils/utils';

const productAvailabilityInfo = props => {
    const { sku, availabilityState, deliveryWeek } = props;
    const { translate } = useTranslationHook();
    const textId = `tooltip-text-${Utils.getRandomId()}`;

    return (
        <>
            { availabilityState === AVAILABILITY_CONSTANTS.NOT_AVAILABLE_IN_REGION ? (
                    <>
                        <div className={'product-availability availability-not-available'}>
                            <span id={textId}>{translate('Delivery not possible', { ns: 'availability' })}</span>
                            <div className={'tooltip-container tooltip-inline'}>
                                <Tooltip
                                    title={''}
                                    content={translate('Exporting this item to the country you have selected is unfortunately not possible.', { ns: 'availability'})}
                                    id={`tooltip-availability-${sku}-${Utils.getRandomId()}`}
                                    isHoverEnabled={false}
                                    iconStyle={'error'}
                                    textId={textId}
                                />
                            </div>
                        </div>
                    </>
                ) :
                availabilityState === AVAILABILITY_CONSTANTS.DELIVERED_ON_DATE ? (
                    <>
                        <div className={'product-availability availability-delivered-on-date'}>
                            <span id={textId}>{`${translate('Available from week', { ns: 'availability' })} ${deliveryWeek}`}</span>
                            <div className={'tooltip-container tooltip-inline'}>
                                <Tooltip
                                    title={''}
                                    content={translate('The product has already been reordered and will be available again from the date shown.', { ns: 'availability' })}
                                    id={`tooltip-availability-${sku}-${Utils.getRandomId()}`}
                                    isHoverEnabled={false}
                                    iconStyle={'warning'}
                                    textId={textId}
                                />
                            </div>
                        </div>
                    </>
                ) :
                availabilityState === AVAILABILITY_CONSTANTS.WILL_BE_ORDERED ? (
                    <>
                        <div className={'product-availability availability-will-be-ordered'}>
                            <span id={textId}>{translate('Available in 7-21 days', { ns: 'availability' })}</span>
                            <div className={'tooltip-container tooltip-inline'}>
                                <Tooltip
                                    title={''}
                                    content={translate(`The product will be ordered from the manufacturer for you. Depending on availability, longer delivery times are also possible. We'll let you know if that's the case. You can of course cancel your delivery at any time free of charge.`, { ns: 'availability' })}
                                    id={`tooltip-availability-${sku}-${Utils.getRandomId()}`}
                                    isHoverEnabled={false}
                                    iconStyle={'success'}
                                    textId={textId}
                                />
                            </div>
                        </div>
                    </>
                ) :
                availabilityState === AVAILABILITY_CONSTANTS.SOLD_OUT ? (
                    <>
                        <div className={'product-availability availability-sold-out'}>
                            <span id={textId}>{translate('Sold out', { ns : 'availability' })}</span>
                            <div className={'tooltip-container tooltip-inline'}>
                                <Tooltip
                                    title={''}
                                    content={translate('Sorry, this item is sold out', { ns : 'availability' })}
                                    id={`tooltip-availability-${sku}-${Utils.getRandomId()}`}
                                    isHoverEnabled={false}
                                    iconStyle={'error'}
                                    textId={textId}
                                />
                            </div>
                        </div>
                    </>
                ) :
                availabilityState === AVAILABILITY_CONSTANTS.NOT_AVAILABLE ? (
                    <>
                        <div className={'product-availability availability-not-available'}>
                            <span id={textId}>{translate('Not available', { ns: 'availability' })}</span>
                            <div className={'tooltip-container tooltip-inline'}>
                                <Tooltip
                                    title={''}
                                    content={translate('The item is no longer available, please choose an alternative.', { ns: 'availability' })}
                                    id={`tooltip-availability-${sku}-${Utils.getRandomId()}`}
                                    isHoverEnabled={false}
                                    iconStyle={'error'}
                                    textId={textId}
                                />
                            </div>
                        </div>
                    </>
                ) :
                availabilityState === AVAILABILITY_CONSTANTS.AVAILABLE ? (
                    <>
                        <div className={'product-availability availability-available'}>
                            <span id={textId}>{translate('Available', {ns: 'availability' })}</span>
                            <div className={'tooltip-container tooltip-inline'}>
                                <Tooltip
                                    title={''}
                                    content={<div dangerouslySetInnerHTML={{__html: translate('The item is usually shipped from Germany within 1-3 working days. Note: Stocks are updated online every hour on working days from 7 a.m. to 8 p.m., so there is a good chance that the products are available if they appear online.', { ns: 'availability' })}} />}
                                    id={`tooltip-availability-${sku}-${Utils.getRandomId()}`}
                                    isHoverEnabled={false}
                                    iconStyle={'success'}
                                    textId={textId}
                                />
                            </div>
                        </div>
                    </>
                ) :
                    <></>
            }
        </>
    );
};

export default productAvailabilityInfo;
